import type { AliasToken } from 'antd/es/theme/interface';

import {
  BlueColors,
  GreenColors,
  NeutralColors,
  RedColors,
  YellowColors
} from './colors';

export const ThemeTokens: Partial<AliasToken> = {
  colorPrimary: BlueColors[60],
  colorInfo: BlueColors[60],
  colorPrimaryHover: BlueColors[50],
  colorPrimaryBg: BlueColors[10],
  colorPrimaryBgHover: BlueColors[20],
  colorPrimaryBorder: BlueColors[60],
  colorPrimaryBorderHover: BlueColors[50],
  colorPrimaryActive: BlueColors[60],
  colorPrimaryText: BlueColors[50],
  colorPrimaryTextHover: BlueColors[50],
  colorPrimaryTextActive: BlueColors[60],
  colorSuccess: GreenColors[60],
  colorSuccessBg: GreenColors[10],
  colorSuccessBgHover: GreenColors[50],
  colorSuccessBorder: GreenColors[30],
  colorSuccessBorderHover: GreenColors[50],
  colorSuccessHover: GreenColors[50],
  colorSuccessActive: GreenColors[60],
  colorSuccessTextHover: GreenColors[50],
  colorSuccessText: GreenColors[60],
  colorSuccessTextActive: GreenColors[60],
  colorWarningBg: YellowColors[10],
  colorWarningBgHover: YellowColors[20],
  colorWarningBorder: YellowColors[30],
  colorWarningBorderHover: YellowColors[40],
  colorWarningHover: YellowColors[40],
  colorWarning: YellowColors[40],
  colorWarningActive: YellowColors[50],
  colorWarningTextHover: YellowColors[40],
  colorWarningText: YellowColors[50],
  colorWarningTextActive: YellowColors[50],
  colorErrorBg: RedColors[10],
  colorErrorBgHover: RedColors[20],
  colorErrorBorder: RedColors[20],
  colorErrorBorderHover: RedColors[50],
  colorErrorHover: RedColors[50],
  colorErrorText: RedColors[60],
  colorErrorTextActive: RedColors[60],
  colorErrorTextHover: RedColors[50],
  colorError: RedColors[60],
  colorErrorActive: RedColors[50],
  colorTextBase: NeutralColors[100],
  borderRadius: 8,
  boxShadow: '0 2px 8px rgba(0, 0, 0, 0.05)'
};
